import React from "react";
import Icon from "./Icon";

// Padrao semantico de cores (mockup-tags.html):
//   gray   -> pasta            -> manuais, normas, procedimentos
//   teal   -> grafico          -> metricas, progresso, analise
//   amber  -> prancheta        -> afazeres, formularios
//   purple -> chapeu formatura -> cursos, treinamentos
//   blue   -> cadeado          -> privacidade, seguranca
//   coral  -> pessoas          -> assuntos gerais da empresa
const colorIconMap = {
  gray:       ["ic-gray",   "folder"],
  teal:       ["ic-teal",   "chart"],
  amber:      ["ic-amber",  "clipboard"],
  purple:     ["ic-purple", "school"],
  blue:       ["ic-blue",   "lock"],
  coral:      ["ic-coral",  "people"],
  // Aliases legados — antes "restricted" era violeta com cadeado.
  // Mapeia para o novo "blue" (mesma intencao: seguranca / acesso restrito).
  restricted: ["ic-blue",   "lock"],
};

export default function ToolCard({ title, desc, url, color = "gray" }) {
  const [iconClass, iconName] = colorIconMap[color] || colorIconMap.gray;
  return (
    <a className="card" href={url} target="_blank" rel="noreferrer">
      <div className={`card-icon ${iconClass}`}>
        <Icon name={iconName} />
      </div>
      <div className="card-body">
        <div className="card-title">{title}</div>
        {desc && <div className="card-desc">{desc}</div>}
      </div>
    </a>
  );
}
